import { environment } from '../../../environments/environment';
import { Message } from '../models/system/message';
import { Injectable } from '@angular/core';
import { UserManagerService } from './user-manager.service';
import { LoginUser } from '../models/DTO/LoginUser';
import { MatSnackBar, throwMatDialogContentAlreadyAttachedError } from '@angular/material';
import { SnakeComponent } from '../components/snake/snake.component';
import { ResponseStatusEnum } from '../models/system/response-status.enum';
import { UserNotification } from '../models/DTO/uer-notification';
import { HttpRequestService } from './http-request.service';
import { AppStorageService } from './app-storage.service';
import { ConfigService } from './config.service';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import {Permission} from  '../models/BasicData/Permission'

@Injectable()
export class Globals {
   messages: Message[];
   spinner: boolean;
   afterloginspinner: boolean;
   status: ResponseStatusEnum;
   private notifications: UserNotification[];
   private roleCode: string;
   private userId: string;
   private empCompleteData: boolean;
   private patientId: string;
   private email: string;
   private loginFullName: string;
   private userRolesDetails;
   public currentTerm=201910;
   public perms:Permission[]=[];
   public permissionsMenu :Permission[]=[];
   subscribePatientId: Subject<string>;
   constructor ( private configService: ConfigService, private appStore: AppStorageService, private snackBar: MatSnackBar, private httpRes: HttpRequestService , public translate: TranslateService) {
      this.subscribePatientId = new Subject<string>();
      //this.roleCode = 'EmployeePatient'; // For demo show
      //this.roleCode = 'Admin'; // For demo show
//console.log(this.UserData);
      if (this.UserData != null) {
         this.roleCode = this.UserData.roleCode[0];
         this.empCompleteData = this.UserData.completeData;
         this.patientId = this.UserData.patientId;
         this.userRolesDetails=this.UserData.rolesDetails;
      }
  this.perms= this.getPermissions();
console.log('perms'+this.perms);
   }
  

   savePermissions()
   {
     this.appStore.setItem("perms",JSON.stringify(this.perms));
   }
   getPermissions()
   {
    return  JSON.parse( this.appStore.getItem("perms"));
   }
   get IsLogin() {
      return true; // For demo show
      //return this.UserData != null;
   }

   get Notifications() {
      if (this.notifications === null || this.notifications === undefined) {
         this.notifications = new Array();
      }
      return this.notifications;
   }
   set Notifications(value) {
      this.notifications = value;
   }
   set Messages(msgs: Message[]) {
      if (msgs != null) {
         // tslint:disable-next-line: prefer-for-of
         for (let i = 0; i < msgs.length; i++) {
            // this.snackBar.open(msgs[0].body, '', {
            //    duration: 1000,
            // });
            this.messages = msgs;

         }
      }
      else {
         this.messages = null;
      }
   }
   get Messages() {
      return this.messages;

   }
   get UserData() {

      return JSON.parse(this.appStore.getItem(this.configService.getUserData()));

   }

   /*  this.snackBar.openFromComponent(SnakeComponent, {
       duration: 5000,
     });*/

   get EmpCompleteData() {
      return this.empCompleteData;
   }

   set EmpCompleteData(empCompleteData: boolean) {
      
      let updatedUserData = this.UserData;
      updatedUserData.completeData = empCompleteData;
      this.appStore.removeItem(this.configService.getUserData());
      this.appStore.setItem(this.configService.getUserData() , JSON.stringify(updatedUserData));
      this.empCompleteData = empCompleteData;
     

   }
   get Email() {

      if (this.email == "" || this.email == null) {
         // return 'Admin';// For demo show
         return this.UserData.email;
      }
      else {
         return this.email;
      }
   }

   get LoginUserId() {
      //return 'Admin';// For demo show
      return this.UserData.userId;
   }

   get LoginPatientId() {
   
      return this.UserData.patientId;
   }

   get LoginFullName() {
      return this.UserData.firstName + ' ' + this.UserData.lastName;
   }

   get LoginUserName() {
      // return 'Admin';// For demo show
      // console.log(JSON.parse(this.appStore.getItem(this.configService.getUserData())));
      return this.UserData.userName;

   }
   get LoginEmail() {
      // return 'Admin';// For demo show
      // console.log(JSON.parse(this.appStore.getItem(this.configService.getUserData())));
      return this.UserData.email;

   }
   get UserId() {
      if (this.UserData != null){

         if (this.userId == "" || this.userId == null) {
            // return 'Admin';// For demo show
            return this.UserData.userId;
         }
         else {
            return this.userId;
         }
      }
      else{
         return "";
      }
   }

 
   set UserId(userId) {
      this.userId = userId;
   }

   set FirstName(firstName) {

      let updatedUserData = this.UserData;
      updatedUserData.firstName =firstName;
      this.appStore.removeItem(this.configService.getUserData());
      this.appStore.setItem(this.configService.getUserData() , JSON.stringify(updatedUserData));
      this.UserData.firstName = firstName;
     
   }
   set LastName(lasttName) {
      let updatedUserData = this.UserData;
      updatedUserData.lastName =lasttName;
      this.appStore.removeItem(this.configService.getUserData());
      this.appStore.setItem(this.configService.getUserData() , JSON.stringify(updatedUserData));
      this.UserData.lasttName = lasttName;
   }

   set LoginFullName(name) {
       this.loginFullName  = name;
   }
 set Email(email) {
      this.email = email;
   }
   get UserName() {
      //return 'Admin';// For demo show

      return this.UserData.userName;
   }



   get FirstName() {

      //  return 'Admin';// For demo show
      return this.UserData.firstName;
   }

   get LastName() {

      //return 'Admin';// For demo show
      return this.UserData.lastName;
   }

   get PhoneNumber() {
      //return 'Admin';// For demo show

      return this.UserData.phoneNumber;
   }

   get Role() {

      return this.roleCode;


   }

   get RolesDetails() {
      return this.UserData.rolesDetails;
   }

   set Role(enteredRole) {
      //this.UserData.roleCode[0] = enteredRole;
      this.roleCode = enteredRole;
   }



   get loginToken() {
      return localStorage.getItem(this.configService.getToken());
   }
   get ApiUrl() {
      return environment.API_URL;
   }



   getOrigin() {

      return location.origin;
   }

   exportCourseSpecfication(id) {
      this.httpRes.GetRequest('CourseSpecfication/export/' + id).toPromise();
   }

   downloadFile(data: Response) {
      // const blob = new Blob([data], { type: 'application/pdf' });
      //const url = window.URL.createObjectURL(blob);
      // window.open(url);
   }

  
   useLTR(lang) {
      return new Promise((resolve, reject) =>{
      this.translate.use(lang);
      document.getElementById('AR2').setAttribute('href', 'assets/css/bootstrap4/bootstrap.min.css');
      document.getElementById('AR').setAttribute('href', 'assets/css/seo-style.css');
      document.getElementById('AR1').setAttribute('href', 'assets/css/style.css');
      document.getElementById('AR4').setAttribute('href', 'assets/css/style-login.css');
      document.getElementById('AR5').setAttribute('href', 'assets/css/style-landing.css');
      });
  
    }
  
    userRTL(lang) {
      return new Promise((resolve, reject) =>{
      this.translate.use(lang);
      document.getElementById('AR2').setAttribute('href', 'assets/css/bootstrap4/bootstrap-rtl.min.css');
      document.getElementById('AR').setAttribute('href', 'assets/css/seo-style-rtl.css');
      document.getElementById('AR1').setAttribute('href', 'assets/css/style-rtl.css');
      document.getElementById('AR4').setAttribute('href', 'assets/css/style-login-rtl.css');
      document.getElementById('AR5').setAttribute('href', 'assets/css/style-landing-rtl.css');
      });
}



get CurrentLang(  )
{
   return this.translate.currentLang;
}


public  readonly(permssionCode:string) :boolean
{
   let val:boolean;
    val=false;
   console.log(permssionCode);
   console.log(this.perms);
   this.getPermissions().forEach(element => {
     console.log(element.elementId)
      if(element.elementId==permssionCode)
      {
        console.log( permssionCode+' readonly:'+element.isReadOnly);
         val= element.isReadOnly;
      }
   });
   console.log(val)
   return val;
}
public  hide(permssionCode:string) :boolean
{
   let val:boolean;
    val=false;
 console.log('hide');
 console.log(this.getPermissions());
 console.log('hide2');
 
 this.getPermissions().forEach(element => {
   console.log('hide3');

   if(element.elementId==permssionCode)
      {
         console.log('hide4');

        console.log(permssionCode+' hide:'+element.isHidden);
         val= element.isHidden;
      }
   });
   return val;
}
public  rw(permssionCode:string) :boolean
{
   let val:boolean;
    val=false;
   console.log(permssionCode);
   console.log(this.perms);
   this.getPermissions().forEach(element => {
     console.log(element.elementId)
      if(element.elementId==permssionCode)
      {
         console.log('permssionCode rw:'+element.isReadWrite);

        console.log(element.isReadWrite);
         val= element.isReadWrite;
      }
   });
   console.log('rw:'+val)
   return val;
}
}